import styled from 'styled-components';

const StyledDescription = styled.div`
  width: 100%;
  flex-grow: 1;
`;

export default StyledDescription;
